// extracted by mini-css-extract-plugin
export default {"label":"label-local__label___Msnj8Sh2","fauxLabel":"label-local__fauxLabel___ZPFUyuV3"};